    <!-- HEADER -->
    <div style="float:left;">
      <h2 mat-dialog-title><span translate>{{report.Description}}</span></h2>
    </div>
    <!-- CONTENT -->
    <mat-dialog-content>
      <table style="width:100%;" st-select-row="parameterRow" st-select-mode="single">
        <tr>
          <td>
            <div>
              <table>
                <tr>
                  <td colspan="3" style="padding-top:5px;">
                    <tyl-form-field label="Report Title" style="width:350px;">
                      <input matInput name="ReportTitle" id="ReportTitle" [(ngModel)]="reportParameter.ReportTitle" />
                    </tyl-form-field>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" style="padding-top:5px;">
                    <tyl-datepicker label="Report Date" style="width:350px;"
                       name="PrintDate" id="PrintDate" [(value)]="reportParameter.PrintDate" >
                    </tyl-datepicker>
                  </td>
                </tr>
              </table>
            </div>
          </td>
        </tr>

      </table>

    </mat-dialog-content>
    <!-- Footer -->
    <mat-dialog-actions>
      <!-- Footer -->
      <div class="flex-footer-left" style="align-items: center; width: 30%">
      </div>
      <div class="flex-footer-right" style="align-items: center; width: 70%">
        <!-- ERROR PROMPT -->
        <error-prompt [errorList]="errors"></error-prompt>
        <!-- CANCEL -->
        <tyl-button style="float:right; color: black;" image="save.png" label="Run" (clickEvent)="runClick()">
        </tyl-button>
        <tyl-button style="float:right; color: black;" image="cancel.png" label="Cancel"
          (clickEvent)="cancelShowReportParameters()"></tyl-button>
      </div>
    </mat-dialog-actions>
